<template>
  <v-app id="inspire">
    <!-- Background Carousel -->
    <div class="background-carousel">
      <transition name="fade" mode="out-in">
        <img :key="currentImageIndex"
             :src="backgroundImages[currentImageIndex]"
             alt="background"
             class="bg-image" />
      </transition>
      <div class="bg-overlay"></div>
    </div>

    <!-- DESKTOP LAYOUT -->
    <div hidden-md-and-down>
      <v-navigation-drawer fixed
                           :clipped="$vuetify.breakpoint.lgAndUp"
                           app
                           v-model="drawer"
                           class="custom-drawer">
        <v-list dense class="drawer-list">
          <template v-for="item in menu">
            <v-layout row
                      v-if="item.heading"
                      align-center
                      :key="item.heading">
              <v-flex xs6>
                <v-subheader class="drawer-heading">{{ item.heading }}</v-subheader>
              </v-flex>
              <v-flex xs6 class="text-xs-center">
                <a href="#!" class="body-2 white--text">EDIT</a>
              </v-flex>
            </v-layout>

            <v-list-group v-else-if="item.features"
                          v-model="item.model"
                          :key="item.text"
                          :prepend-icon="item.model ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
                          append-icon=""
                          class="drawer-group">
              <v-list-tile slot="activator">
                <v-list-tile-content>
                  <v-list-tile-title class="drawer-item-title">{{ item.name }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile v-for="(child, i) in item.features"
                           :key="i"
                           @click="navigateTo(child.url)"
                           class="drawer-child">
                <v-list-tile-action v-if="child.icon">
                  <v-icon class="drawer-icon">{{ child.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title class="drawer-child-title">{{ child.name }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list-group>

            <v-list-tile v-else :key="item.text" class="drawer-item" @click="navigateTo(item.url)">
              <v-list-tile-action>
                <v-icon class="drawer-icon">{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title class="drawer-item-title">{{ item.name }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>
      </v-navigation-drawer>

      <v-toolbar color="primary"
                 dark
                 app
                 :clipped-left="$vuetify.breakpoint.lgAndUp"
                 fixed
                 class="custom-toolbar">
        <v-toolbar-title style="width: 300px" class="ml-0 pl-2">
          <v-toolbar-side-icon @click.stop="drawer = !drawer" class="white--text"></v-toolbar-side-icon>
          <span class="earth white--text">OL PEJETA CONSERVANCY</span>
        </v-toolbar-title>

        <v-btn flat class="white--text">{{$user_type}}</v-btn>
        <v-btn flat v-if="isOffLine" class="white--text">You have no internet connection</v-btn>
        <span class="white--text version-badge">{{singleLatestVersion}}</span>

        <v-spacer></v-spacer>

        <!-- Currency menu -->
        <v-menu offset-y>
          <v-btn flat slot="activator" class="white--text">Currency <v-icon class="white--text">keyboard_arrow_down</v-icon></v-btn>
          <v-list>
            <v-list-tile v-for="(currency, key) in allCurrencies"
                         @click="currencyChange(currency)"
                         :key="key">
              <v-list-tile-title>{{currency.currency_name}}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>

        <!-- Current currency -->
        <v-menu offset-y>
          <v-btn flat slot="activator" class="white--text">Current Currency : {{current_currency}}</v-btn>
        </v-menu>

        <!-- User menu -->
        <v-menu offset-y>
          <v-btn flat slot="activator" class="white--text">{{user_name}} <v-icon class="white--text">keyboard_arrow_down</v-icon></v-btn>
          <v-list>
            <v-list-tile @click="doLogout()">
              <v-list-tile-title>Logout</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar>
    </div>

    <!-- MOBILE LAYOUT -->
    <div hidden-md-and-up>
      <v-toolbar color="primary" dark app fixed class="custom-toolbar">
        <v-toolbar-side-icon @click.stop="drawerMobile = !drawerMobile" class="white--text"></v-toolbar-side-icon>
        <v-toolbar-title class="earth white--text">OL PEJETA</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-navigation-drawer v-model="drawerMobile"
                           temporary
                           fixed
                           app
                           class="custom-drawer">
        <v-list dense class="drawer-list">
          <template v-for="item in menu">
            <v-list-group v-if="item.features"
                          v-model="item.model"
                          :key="item.name"
                          :prepend-icon="item.model ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
                          append-icon=""
                          class="drawer-group">
              <v-list-tile slot="activator">
                <v-list-tile-content>
                  <v-list-tile-title class="drawer-item-title">{{ item.name }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile v-for="(child, i) in item.features"
                           :key="i"
                           @click="navigateTo(child.url)"
                           class="drawer-child">
                <v-list-tile-action v-if="child.icon">
                  <v-icon class="drawer-icon">{{ child.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title class="drawer-child-title">{{ child.name }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list-group>

            <v-list-tile v-else :key="item.name" @click="navigateTo(item.url)" class="drawer-item">
              <v-list-tile-action>
                <v-icon class="drawer-icon">{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title class="drawer-item-title">{{ item.name }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>

          <!-- Bottom menu with smooth rounded edges -->
          <div class="bottom-menu-wrapper">
            <v-divider class="drawer-divider"></v-divider>
            <div class="bottom-menu-card">
              <!-- Currency for mobile -->
              <v-subheader class="drawer-heading">Currency</v-subheader>
              <v-list-tile v-for="(currency, key) in allCurrencies"
                           :key="key"
                           @click="currencyChange(currency)"
                           class="drawer-item bottom-item">
                <v-list-tile-title class="drawer-item-title">{{currency.currency_name}}</v-list-tile-title>
              </v-list-tile>

              <v-list-tile class="drawer-item bottom-item">
                <v-list-tile-title class="drawer-item-title">Current Currency: {{current_currency}}</v-list-tile-title>
              </v-list-tile>

              <v-divider class="drawer-divider"></v-divider>

              <!-- User -->
              <v-list-tile @click="doLogout()" class="drawer-item bottom-item">
                <v-list-tile-title class="drawer-item-title">Logout</v-list-tile-title>
              </v-list-tile>
            </div>
          </div>
        </v-list>
      </v-navigation-drawer>
    </div>

    <!-- Main content -->
    <v-content>
      <v-container fluid class="main-content">
        <router-view />
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  export default {
    name: 'Back',
    data: () => ({
      user_name: localStorage.getItem('user_name'),
      dialog: false,
      drawer: true,
      drawerMobile: false,
      current_currency: 'KES',
      icon: 'keyboard_arrow_up',
      'icon-alt': 'keyboard_arrow_down',
      items: [
        { icon: 'contacts', text: 'Contacts' },
        {
          text: 'Labels',
          model: false,
          children: [
            { icon: 'add', text: 'Create label' }
          ]
        }
      ],
      // Carousel data
      backgroundImages: [
        'https://www.olpejetaconservancy.org/wp-content/uploads/2026/02/Family-Camping@Ewaso-Campsite-1-scaled.jpg',
        'https://www.olpejetaconservancy.org/wp-content/uploads/2026/02/camping-edit-8-scaled.jpg',
        'https://www.olpejetaconservancy.org/wp-content/uploads/2024/09/Black-rhino-calf-2-1.webp',
        'https://www.olpejetaconservancy.org/wp-content/uploads/2024/07/IMG_0110-3-scaled.webp',
        'https://www.olpejetaconservancy.org/wp-content/uploads/2024/08/jc-pieri-olpejeta-35.webp',
        'https://www.olpejetaconservancy.org/wp-content/uploads/2024/07/Cheetah-5-scaled.webp',
        'https://www.olpejetaconservancy.org/wp-content/uploads/2024/07/DSC_0772-scaled.webp'
      ],
      currentImageIndex: 0,
      intervalId: null
    }),
    created() {
      this.$store.dispatch('get_all_currencies')
      this.$store.dispatch('get_single_change_log')
    },
    mounted() {
      this.startCarousel()
    },
    beforeDestroy() {
      this.stopCarousel()
    },
    watch: {
      isOffLine(val) {
        if (val) {
          alert('You seem to be offline!!')
          return 'You are offline'
        }
      }
    },
    methods: {
      navigateTo: function (url) {
        this.$router.push({
          name: url
        })
      },
      currencyChange: function (data) {
        this.current_currency = data.currency_name
        this.$store.commit('LOCAL_CURRENCY2', data)
      },
      doLogout() {
        const trackerId = localStorage.getItem('tracker_id')
        this.$store.dispatch('reset_storage', trackerId)
      },
      startCarousel() {
        this.intervalId = setInterval(() => {
          this.currentImageIndex = (this.currentImageIndex + 1) % this.backgroundImages.length
        }, 30000) // Change every 5 seconds
      },
      stopCarousel() {
        if (this.intervalId) {
          clearInterval(this.intervalId)
          this.intervalId = null
        }
      }
    },
    props: {
      source: String
    }
  }
</script>

<style scoped>
  /* ------------------------------------------------------------
     GLOBAL STYLING – Inspired by CheckIn.vue's glassy green theme
     while retaining all original Back.vue functionality
  -------------------------------------------------------------- */

  /* ─── BACKGROUND CAROUSEL ─── */
  .background-carousel {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    overflow: hidden;
  }

  .bg-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .bg-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.15);
    z-index: 1;
    pointer-events: none;
  }

  /* Fade transition */
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 1.5s ease;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  /* ─── TOOLBAR ─── */
  .custom-toolbar {
    background: linear-gradient(135deg, #1b5e20 0%, #2e7d32 100%) !important;
    border-bottom: 3px solid #4caf50 !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2) !important;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
  }

    .custom-toolbar .v-btn {
      text-transform: none !important;
      letter-spacing: 0.3px;
      font-weight: 500;
      border-radius: 60px !important;
      transition: all 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    }

      .custom-toolbar .v-btn:hover {
        background: rgba(255, 255, 255, 0.15) !important;
        transform: translateY(-2px);
      }

  .earth {
    font-weight: 700;
    letter-spacing: 1.5px;
    color: #ffffff !important;
    text-shadow: 0 0 12px rgba(76, 175, 80, 0.5);
    font-family: Earthwerk, 'Knockout', 'Montserrat', sans-serif;
  }

  .custom-toolbar .v-toolbar__title .v-icon {
    color: #ffffff !important;
  }

  .custom-toolbar .v-toolbar-side-icon {
    color: #ffffff !important;
  }

  /* Version badge */
  .version-badge {
    background: rgba(255, 255, 255, 0.15);
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 0.85rem;
    font-weight: 600;
    border: 1px solid rgba(255, 255, 255, 0.3);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
  }

  /* ─── DRAWER ─── */
  .custom-drawer {
    background: rgba(241, 248, 233, 0.92) !important;
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-right: 1px solid rgba(165, 214, 167, 0.5) !important;
    box-shadow: 4px 0 20px rgba(0, 0, 0, 0.08) !important;
  }

  .drawer-list {
    padding-top: 12px;
  }

  .drawer-heading {
    color: #2e7d32 !important;
    font-weight: 700;
    font-size: 0.75rem;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    padding-left: 16px !important;
  }

  .drawer-item {
    border-radius: 8px !important;
    margin: 2px 8px !important;
    transition: all 0.2s ease !important;
  }

    .drawer-item:hover {
      background: rgba(46, 125, 50, 0.12) !important;
      transform: translateX(4px);
    }

  .drawer-item-title {
    color: #1b5e20 !important;
    font-weight: 500;
    font-size: 0.95rem;
  }

  .drawer-icon {
    color: #388e3c !important;
    transition: color 0.2s;
  }

  .drawer-item:hover .drawer-icon {
    color: #1b5e20 !important;
  }

  .drawer-group {
    border-radius: 8px !important;
    margin: 2px 8px !important;
  }

    .drawer-group .v-list__group__header {
      border-radius: 8px !important;
    }

      .drawer-group .v-list__group__header:hover {
        background: rgba(46, 125, 50, 0.08) !important;
      }

  .drawer-child {
    padding-left: 32px !important;
    border-radius: 8px !important;
    margin: 2px 8px 2px 16px !important;
    transition: all 0.2s ease !important;
  }

    .drawer-child:hover {
      background: rgba(46, 125, 50, 0.10) !important;
      transform: translateX(4px);
    }

  .drawer-child-title {
    color: #2e7d32 !important;
    font-weight: 400;
  }

  .drawer-divider {
    background: rgba(165, 214, 167, 0.6) !important;
    margin: 8px 0 !important;
  }

  .custom-drawer .v-list__tile--active {
    background: rgba(46, 125, 50, 0.18) !important;
    border-left: 4px solid #2e7d32 !important;
  }

  /* ─── BOTTOM MENU (mobile drawer) with smooth rounded edges ─── */
  .bottom-menu-wrapper {
    margin: 8px 8px 0 8px;
  }

  .bottom-menu-card {
    background: rgba(255, 255, 255, 0.6);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    border-radius: 16px;
    overflow: hidden;
    border: 1px solid rgba(165, 214, 167, 0.3);
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    padding: 4px 0;
  }

    .bottom-menu-card .drawer-divider {
      margin: 4px 0;
    }

    .bottom-menu-card .drawer-item {
      margin: 0 4px !important;
      border-radius: 8px !important;
    }

      .bottom-menu-card .drawer-item:last-child {
        margin-bottom: 2px !important;
      }

  .bottom-item {
    border-radius: 8px !important;
  }

  /* ─── DROPDOWN ICONS (prepend icons) IN DRAWER ─── */
  .custom-drawer .drawer-group .v-list__group__header .v-icon {
    color: #000000 !important;
  }

  /* ─── MAIN CONTENT ─── */
  .main-content {
    position: relative;
    z-index: 1;
    min-height: 100vh;
    padding: 20px !important;
  }

  /* ─── MENU OVERRIDES (for dropdown menus) ─── */
  .custom-toolbar .v-menu__content .v-list {
    background: rgba(255, 255, 255, 0.92) !important;
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border: 1px solid rgba(165, 214, 167, 0.4) !important;
    border-radius: 16px !important;
    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.12) !important;
  }

  .custom-toolbar .v-menu__content .v-list__tile {
    color: #1b5e20 !important;
    border-radius: 8px !important;
    transition: all 0.2s ease;
  }

    .custom-toolbar .v-menu__content .v-list__tile:hover {
      background: rgba(46, 125, 50, 0.10) !important;
      transform: translateX(4px);
    }

  .custom-toolbar .v-menu__content .v-list__tile-title {
    color: #1b5e20 !important;
    font-weight: 500;
  }

  /* ─── BUTTONS & CONTROLS inside this component ─── */
  .custom-toolbar .v-btn--flat {
    color: #ffffff !important;
  }

    .custom-toolbar .v-btn--flat .v-icon {
      color: #ffffff !important;
    }

  .custom-toolbar .v-input__slot {
    color: #1b5e20 !important;
  }

  .custom-toolbar .v-label {
    color: #2e7d32 !important;
  }

  /* ─── RESPONSIVE ─── */
  @media (max-width: 1264px) {
    .custom-toolbar .v-toolbar__title .earth {
      font-size: 1.1rem;
    }
  }

  /* ─── FORCE WHITE TEXT ONLY ON TOOLBAR ELEMENTS ─── */
  .custom-toolbar .white--text,
  .custom-toolbar .v-toolbar__title,
  .custom-toolbar .v-list__tile__title,
  .custom-toolbar .v-subheader,
  .custom-toolbar .v-btn,
  .custom-toolbar .v-icon,
  .custom-toolbar .earth,
  .custom-toolbar .version-badge {
    color: #ffffff !important;
  }

  /* ─── CARD & TABLE OVERRIDES (optional, only inside main-content) ─── */
  .main-content .v-card {
    background: rgba(255, 255, 255, 0.85) !important;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border: 1px solid rgba(165, 214, 167, 0.4);
    border-radius: 18px !important;
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.06) !important;
  }

  .main-content .v-data-table {
    background: rgba(255, 255, 255, 0.80) !important;
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    border-radius: 16px !important;
    overflow: hidden;
  }

    .main-content .v-data-table th {
      color: #1b5e20 !important;
      font-weight: 600;
    }

    .main-content .v-data-table td {
      color: #1b5e20 !important;
    }

  /* ─── IMPORT EARTHWERK FONT ─── */
  @font-face {
    font-family: Earthwerk;
    font-weight: bold;
    src: url('./../assets/Both/Fonts/Earthwerk/PizzaDude.dk - Earthwerk.otf');
  }

  /* ─── SCROLLBAR STYLING (matches CheckIn.vue) ─── */
  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-track {
    background: rgba(224, 224, 224, 0.5);
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: #74a533;
    border-radius: 10px;
    transition: all 0.3s ease;
  }

    ::-webkit-scrollbar-thumb:hover {
      background: #5e8a2a;
    }
</style>

<style>
  /* ─── GLOBAL STYLES (not scoped) ─── */
  @import url('https://fonts.googleapis.com/css2?family=Inter:opsz,wght@14..32,300;14..32,400;14..32,600;14..32,700;14..32,800&family=Montserrat:wght@400;500;600;700;800&display=swap');

  @font-face {
    font-family: Earthwerk;
    font-weight: bold;
    src: url('./../assets/Both/Fonts/Earthwerk/PizzaDude.dk - Earthwerk.otf');
  }

  .earth {
    font-family: Earthwerk, 'Knockout', 'Montserrat', sans-serif;
  }

  /* ─── GLOBAL RESETS ─── */
  ::-webkit-scrollbar {
    width: 6px;
    background: #c8e6c9;
  }

  ::-webkit-scrollbar-thumb {
    background: #2e7d32;
    border-radius: 10px;
  }

    ::-webkit-scrollbar-thumb:hover {
      background: #1b5e20;
    }
</style>
